/* @flow */

import React from 'react';
import { Grid } from 'semantic-ui-react';

type Props = {
  content: CatalogPageContent,
};

const View = ({ content }: Props) => {
  return (
    <div>
      <Grid>
        <Grid.Row>
          <Grid.Column width="eight">{content.title}</Grid.Column>
          <Grid.Column width="eight">
            {content.external && 'Lien externe'}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width="sixteen">{content.url}</Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/web/View.js